import axiosInstances from '../utils/axiosInstances';

/**
 * @typedef {import('axios').AxiosResponse} AxiosResponse
 */

class RESTWorkflowService {
  #dispatchQoreAxiosInstance;

  constructor() {
    this.#dispatchQoreAxiosInstance = axiosInstances({
      baseURL: process.env.REACT_APP_DISPATCH_QORE_API,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
      },
      withCredentials: true
    });
  }

  /**
   * Returns the entire workflow list used by dispatchQore.
   * Awaiting within the function to return the wrapped data to emulate how the previous GQL call returned data
   * @param {number} [workflowId] - Optional workflow ID to filter the results
   * @returns {Promise<AxiosResponse>}
   */
  async getWorkflows(workflowId = null) {
    const response = await this.#dispatchQoreAxiosInstance.get('/getWorkflows', {
      params: {
        workflowId
      }
    });
    return response.data;
  }
}

export default RESTWorkflowService;
